import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import "./styles/Rules.css";

const Rules = () => {
  const { t } = useTranslation();

  const emblemes = require.context("../medias/embleme", false, /\.png$/);
  const images = Array.from({ length: 130 }, (_, index) => emblemes(`./${index + 1}.png`));

  const [fullscreenImage, setFullscreenImage] = useState(null);

  const handleImageClick = (src) => {
    setFullscreenImage(src);
  };

  const closeFullscreen = () => {
    setFullscreenImage(null);
  };

  return (
    <main className="rules">
      <h1>
        <br />
        {t("rules.title")}
      </h1>

      <div className="rules-container">
        <div className="rules-section">
          <h3>{t("rules.articles.a1.title")}</h3>
          <p>{t("rules.articles.a1.body")}</p>
        </div>

        <div className="rules-section">
          <h3>{t("rules.articles.a1bis.title")}</h3>
          <p>
            {t("rules.articles.a1bis.intro")}
            <br />
            <br />
            1. <strong>{t("rules.articles.a1bis.modeWorldTourTitle")}</strong> :{" "}
            {t("rules.articles.a1bis.modeWorldTourBody")}
            <br />
            2. <strong>{t("rules.articles.a1bis.modeEspoirTitle")}</strong> :{" "}
            {t("rules.articles.a1bis.modeEspoirBody")}
            <br />
            3. {t("rules.articles.a1bis.leaguesBody")}
          </p>
        </div>

        <div className="rules-section">
          <h3>{t("rules.articles.a2.title")}</h3>
          <p>
            1. {t("rules.articles.a2.items.1")}
            <br />
            2. {t("rules.articles.a2.items.2")}
            <br />
            3. {t("rules.articles.a2.items.3")}
            <br />
            4. {t("rules.articles.a2.items.4")}
            <br />
            5. {t("rules.articles.a2.items.5")}
            <br />
            6. {t("rules.articles.a2.items.6")}
            <br />
            7. {t("rules.articles.a2.items.7.before")}{" "}
            <strong>{t("rules.articles.a2.items.7.strong")}</strong>
            <br />
            8. {t("rules.articles.a2.items.8")}
            <br />
            9. {t("rules.articles.a2.items.9")}
          </p>
        </div>

        <div className="rules-section">
          <h3>{t("rules.articles.a3.title")}</h3>
          <p>
            1. {t("rules.articles.a3.items.1")}
            <br />
            2. {t("rules.articles.a3.items.2.before")}{" "}
            <strong>{t("rules.articles.a3.items.2.strong")}</strong>.
            <br />
            3. {t("rules.articles.a3.items.3.before")}{" "}
            <strong>{t("rules.articles.a3.items.3.strong")}</strong>.
            <br />
            4. {t("rules.articles.a3.items.4.before")}{" "}
            <strong>{t("rules.articles.a3.items.4.strong")}</strong>.
            <br />
            5. {t("rules.articles.a3.items.5")}
            <br />
            6. {t("rules.articles.a3.items.6")}
          </p>
        </div>

        <div className="rules-section">
          <h3>{t("rules.articles.a4.title")}</h3>
          <p>
            1. {t("rules.articles.a4.items.1")}
            <br />
            2. {t("rules.articles.a4.items.2")}
            <br />
            3. {t("rules.articles.a4.items.3")}
            <br />
            4. {t("rules.articles.a4.items.4")}
            <br />
            5. {t("rules.articles.a4.items.5")}
          </p>
        </div>

        <div className="rules-section">
          <h3>{t("rules.articles.a5.title")}</h3>
          <p>
            1. {t("rules.articles.a5.items.1")}
            <br />
            2. {t("rules.articles.a5.items.2")}
            <br />
            3. {t("rules.articles.a5.items.3")}
          </p>
        </div>

        <div className="rules-section">
          <h3>{t("rules.articles.a6.title")}</h3>
          <p>
            1. {t("rules.articles.a6.items.1")}
            <br />
            2. {t("rules.articles.a6.items.2.before")}{" "}
            <strong>{t("rules.articles.a6.items.2.strongRewards")}</strong>{" "}
            {t("rules.articles.a6.items.2.middle1")}{" "}
            <strong>{t("rules.articles.a6.items.2.strongSpecialists")}</strong>{" "}
            {t("rules.articles.a6.items.2.middle2")}{" "}
            <strong>{t("rules.articles.a6.items.2.strongChallenges")}</strong>{" "}
            {t("rules.articles.a6.items.2.middle3")}{" "}
            <strong>{t("rules.articles.a6.items.2.strongRoster")}</strong>{" "}
            {t("rules.articles.a6.items.2.after")}
            <br />
            3. {t("rules.articles.a6.items.3")}
            <br />
            4. {t("rules.articles.a6.items.4")}
          </p>
        </div>

        <div className="rules-section">
          <h3>{t("rules.articles.a7.title")}</h3>
          <p>
            1. {t("rules.articles.a7.items.1")}
            <br />
            2. {t("rules.articles.a7.items.2")}
          </p>
        </div>

        <div className="rules-section">
          <h3>{t("rules.life.title")}</h3>
          <p>
            {t("rules.life.line1")}
            <br />
            {t("rules.life.line2.before")} <strong>#EpopéeVF</strong>
            {t("rules.life.line2.after")}
          </p>
        </div>

        <h2>{t("rules.emblemsAllTitle")}</h2>

        <div className="rules-emblemes-container">
          <h3>{t("rules.emblems.specialist")}</h3>
          <div className="rules-emblemes">
            {images.slice(0, 42).map((src, index) => (
              <img
                key={index}
                src={src}
                alt={t("rules.emblemAlt", { n: index + 1 })}
                onClick={() => handleImageClick(src)}
              />
            ))}
          </div>
        </div>

        <div className="rules-emblemes-container2">
          <h3>{t("rules.emblems.challenges")}</h3>
          <div className="rules-emblemes">
            {images.slice(43, 85).map((src, index) => (
              <img
                key={index}
                src={src}
                alt={t("rules.emblemAlt", { n: index + 1 })}
                onClick={() => handleImageClick(src)}
              />
            ))}
          </div>
        </div>

        <div className="rules-emblemes-container">
          <h3>{t("rules.emblems.roster")}</h3>
          <div className="rules-emblemes">
            {images.slice(86, 103).map((src, index) => (
              <img
                key={index}
                src={src}
                alt={t("rules.emblemAlt", { n: index + 1 })}
                onClick={() => handleImageClick(src)}
              />
            ))}
          </div>
        </div>

        <div className="rules-emblemes-container2">
          <h3>{t("rules.emblems.rewards")}</h3>
          <div className="rules-emblemes">
            {images.slice(104, 129).map((src, index) => (
              <img
                key={index}
                src={src}
                alt={t("rules.emblemAlt", { n: index + 1 })}
                onClick={() => handleImageClick(src)}
              />
            ))}
          </div>
        </div>
      </div>

      {fullscreenImage && (
        <div className="rules-fullscreen-container" onClick={closeFullscreen}>
          <img
            src={fullscreenImage}
            alt={t("rules.fullscreenAlt")}
            className="rules-fullscreen-image"
          />
          <div className="rules-close-button" onClick={closeFullscreen}>
            ✖
          </div>
        </div>
      )}
    </main>
  );
};

export default Rules;
